module.exports = __webpack_public_path__ + "dd5c4780709341dfbaaa750ec6434d63.svg";